module.exports = __webpack_public_path__ + "assets/images/amountofPaintings-04.c611c325f63df2df9165b127c00dc150.svg";